import { gql } from '@apollo/client';
import { SortingHourlyDetailDownloadFilterInput } from '../../types/dashboard/DailyHubOperationDetailTypes';

export const GENERATE_SORTING_HOURLY_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateSortingHourlyDetailDownloadReport(
        $filter: SortingHourlyDetailDownloadFilterInput!
        $timezone: String
    ) {
        generateSortingHourlyDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateSortingHourlyDetailDownloadReportVariables {
    filter: SortingHourlyDetailDownloadFilterInput;
    timezone?: string;
}

export interface GenerateSortingHourlyDetailDownloadReportResponse {
    generateSortingHourlyDetailDownloadReport: string;
}
